import React from "react";
export const Thridparties = () => {
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "cms-single-panel cms-article" },
            React.createElement("h1", null, "Software t\u0159et\u00EDch stran"),
            React.createElement("p", null, "            Software vyu\u017E\u00EDv\u00E1 n\u00E1sleduj\u00EDc\u00ED d\u00EDla t\u0159et\u00EDch stran:"),
            React.createElement("ul", null,
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/freepik", title: "Freepik" }, "Freepik"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/kiranshastry", title: "Kiranshastry" }, "Kiranshastry"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/freepik", title: "Freepik" }, "Freepik"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/pixel-perfect", title: "Pixel perfect" }, "Pixel perfect"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/those-icons", title: "Those Icons" }, "Those Icons"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/pixel-perfect", title: "Pixel perfect" }, "Pixel perfect"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/freepik", title: "Freepik" }, "Freepik"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/kiranshastry", title: "Kiranshastry" }, "Kiranshastry"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/pixel-perfect", title: "Pixel perfect" }, "Pixel perfect"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/freepik", title: "Freepik" }, "Freepik"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "http://www.freepik.com", title: "Freepik" }, "Freepik"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://icon54.com/", title: "Pixel perfect" }, "Pixel perfect"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com")),
                React.createElement("li", null,
                    "Icons made by ",
                    React.createElement("a", { href: "https://www.flaticon.com/authors/icongeek26", title: "Icongeek26" }, "Icongeek26"),
                    " from ",
                    React.createElement("a", { href: "https://www.flaticon.com/", title: "Flaticon" }, " www.flaticon.com"))))));
};
